__turbopack_context__.v({
  "buttonsContainer": "styles-module__E4s2MG__buttonsContainer",
  "form": "styles-module__E4s2MG__form",
  "formField": "styles-module__E4s2MG__formField",
  "modalContent": "styles-module__E4s2MG__modalContent",
  "submitButton": "styles-module__E4s2MG__submitButton",
});
